import React from "react";

function AnnexesRules() {
  return (
    <section>
      RÈGLEMENT INTÉRIEUR DE LA SCIC LE MÉDIA AU 12/06/2026.
      <br />
      <strong>
        <a
          href="http://ressources.lemediatv.fr/cooperative/reglement-interieur.pdf"
          style={{ display: "block", marginTop: "20px", textAlign: "center" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Je consulte le règlement intérieur
        </a>
      </strong>
    </section>
  );
}

export default AnnexesRules;
